export enum EStockDimensions {
    DIMENSIONS = 'dimensions',
    FRAMED_DIMENSIONS = 'framedDimensions'
}
